export const GUEST_SITE_START_PORTAL_ID = 'guest-site-start';
export const ACCOMMODATIONS_SLUG = 'accommodations';
export const CUSTOM_PAGE_PATH = 'page';
